import axios from 'axios'
import { FAIR_PRICE_ENDPOINT } from '../../endpoints'
import * as FileSaver from 'file-saver';
import {toast} from 'react-toastify'
import { XML_TYPE } from 'Utilities';


export async function getCSVMarketPrices(){
    try {
         const response =  await axios(`${FAIR_PRICE_ENDPOINT}/getReportMarketPrices`,{responseType:"blob",method:"GET",timeout: 300000})
         const file = new Blob(
             [response.data],
             {
               type: XML_TYPE,
             }
           )
           FileSaver.saveAs(file, `Precios de Mercado.xlsx`)
           toast.success('Archivo descargado correctamente')
           return true
    } catch (error) {
        toast.error('No se pudo descargar el archivo.')
        return false
    }
    
}
